module.exports = __webpack_public_path__ + "assets/img/kur-nukeliauja-elektra.c0e3157c.png";